import { Injectable } from '@angular/core';
import { onCLS, onFCP, onINP, onLCP, onTTFB, Metric } from 'web-vitals';
import { environment } from 'src/environments/environment';

type VitalName = 'CLS' | 'FCP' | 'INP' | 'LCP' | 'TTFB';

@Injectable({ providedIn: 'root' })
export class WebVitalsService {
  private started = false;

  start(): void {
    if (this.started) return;
    if (typeof window === 'undefined') return;
    this.started = true;

    onCLS((m) => this.handle('CLS', m));
    onFCP((m) => this.handle('FCP', m));
    onINP((m) => this.handle('INP', m));
    onLCP((m) => this.handle('LCP', m));
    onTTFB((m) => this.handle('TTFB', m));
  }

  private handle(name: VitalName, metric: Metric): void {
    if (environment.isDebugMode) {
      const color =
        metric.rating === 'good'
          ? '#16a34a'
          : metric.rating === 'needs-improvement'
            ? '#f59e0b'
            : '#dc2626';
      console.log(
        `%c[WebVital ${name}]%c ${this.format(name, metric.value)} (${metric.rating})`,
        `background:${color};color:white;padding:2px 6px;border-radius:4px;font-weight:bold`,
        '',
        metric,
      );
    }
  }

  private format(name: VitalName, value: number): string {
    if (name === 'CLS') return value.toFixed(3);
    return `${Math.round(value)}ms`;
  }
}
